var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "counter-draft-form",
      attrs: { visible: _vm.showModal, size: "medium", title: _vm.title },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: function($event) {
          return _vm.$emit("close-popup")
        }
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c("div", { staticClass: "dialog__default" }, [
          _c(
            "p",
            { staticClass: "grey mb-2 typographies-paragraph-medium-regular" },
            [_vm._v(_vm._s(_vm.subtitle) + " "), _c("br")]
          ),
          _vm._v(" "),
          _vm.counterLoaded
            ? _c(
                "div",
                {
                  staticClass: "form well well-no-shadow counter-customisation"
                },
                [
                  _c("div", { staticClass: "flex-row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "pt-3 mr-2 typographies-paragraph-medium-semibold"
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.label) +
                            "\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "ml-2 w-1 typographies-paragraph-medium-regular"
                      },
                      [
                        _c("label", { attrs: { for: "identcounter" } }, [
                          _vm._v(_vm._s(_vm.$l10n.__("Compteur")))
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          class: [{ "has-error": "counter" in _vm.errors }],
                          attrs: {
                            maxlength: _vm.counter.identcounterzerofill
                          },
                          model: {
                            value: _vm.counter.identcounter,
                            callback: function($$v) {
                              _vm.$set(_vm.counter, "identcounter", $$v)
                            },
                            expression: "counter.identcounter"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex-row" }, [
                    "root" in _vm.errors
                      ? _c("div", { staticClass: "error-msg" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.errors.root) +
                              "\n                    "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    "counter" in _vm.errors
                      ? _c("div", { staticClass: "error-msg ml-3" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.errors.counter) +
                              "\n                    "
                          )
                        ])
                      : _vm._e()
                  ])
                ]
              )
            : _c(
                "div",
                { staticClass: "loader-container prelative mt-5" },
                [_c("preloader", { attrs: { display: true } })],
                1
              )
        ])
      ]),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "dialog__footer" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("common.actions.cancel"),
                type: "secondary"
              },
              on: {
                click: function($event) {
                  return _vm.$emit("close-popup")
                }
              }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              staticClass: "ml-3",
              attrs: {
                label: _vm.$t.__("common.actions.save"),
                type: "primary"
              },
              on: {
                click: function($event) {
                  return _vm.save()
                }
              }
            })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }